import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../../environments/environment";
@Pipe({
    name: "noDecimalRecipie"
})
export class NoDecimalRecipiePipe implements PipeTransform {
    transform(val: number): string {
        if (val !== undefined && val !== null) {
            // here we just remove the commas from value
            return Number(val.toString().replace(",", "")).toFixed(environment.RecipieDigits);
        } else {
            return "";
        }
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/pipe/nodecimalrecipie.pipe.ts